import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { newFetch, GET, POST } from '../../../helpers/fetch'
import Rating from '../../Input/Rating'
import ToastUtil from "../../../components/ToastNotification/ToastUtil";
import AlertService from "../../../components/SweetAlert";
const PulseSurvey = ({ history, client, activeSchedule }) => {
  const user = JSON.parse(localStorage.getItem('user'))

  const [surveys, setSurveys] = useState([])
  const [answers, setAnswers] = useState([])
  const [answeredSurveys, setAnsweredSurveys] = useState([])

  const fetchSurveys = async () => {
    let api_path = `/client/${client.id}/survey`
    let response = await newFetch(GET, api_path)
    if (response && response.data.length > 0) {
      let filteredData = response.data.filter(survey => survey.active)
      setSurveys(filteredData)
    } else {
      setSurveys([])
    }
  }

  const fetchAnsweredSurveys = async () => {
    let api_path = `/schedule/${activeSchedule.schedule_id}/survey`
    let response = await newFetch(GET, api_path)

    if (response.data && response.data.length > 0) {
      let remappedData = response.data
        .map(survey =>
          survey.answers.find(
            answer =>
              answer.associate_id === user.id &&
              answer.schedule_id === activeSchedule.schedule_id
          )
        )
        .filter(answer => answer !== undefined)

      setAnsweredSurveys(remappedData)
    } else {
      setAnsweredSurveys([])
    }
  }

  const handleAnswer = (survey_id, value, type = "rating") => {
    let clone = [...answers]
    let findAnswer = clone.find(answer => answer.survey_id === survey_id)
    if (findAnswer) {
      let answerIndex = clone.findIndex(
        answer => answer.survey_id === survey_id
      )
      clone[answerIndex].answer = value.toString()
    } else {
      clone.push({
        survey_id,
        answer: value.toString(),
        type
      })
    }

    setAnswers(clone)
  }

  const handleSubmitAnswer = async e => {
    e.preventDefault()

    if (await AlertService.confirm("", "Are you sure you want to submit the Pulse Survey?")) {
      let api_path = `/schedule/${activeSchedule.schedule_id}/survey/answer`
      let response = await newFetch(POST, api_path, { answers })
      ToastUtil.success(response.message)
      if (response.success) {
        setAnswers([])
        fetchAnsweredSurveys()
      }
    }
  }

  useEffect(() => {
    if (activeSchedule) {
      fetchSurveys()
      fetchAnsweredSurveys()
    } else {
      setSurveys([])
    }
  }, [activeSchedule])

  return (
    <div className="container py-2">
      <div className="shadow-sm border-0 rounded bg-white">
        <div className="container pb-2">
          <h6 className="py-2">Pulse Survey</h6>
          <form className="form" onSubmit={e => handleSubmitAnswer(e)}>
            <div className="d-flex flex-column">
              <ol style={{ paddingInlineStart: '15px', paddingLeft: '15px' }}>
                {surveys.length > 0 &&
                  surveys.map((survey, index) => (
                    <li
                      style={{
                        paddingLeft: '15px',
                        marginBottom: index + 1 < surveys.length ? '1.2rem' : ''
                      }}
                      key={survey.id}
                    >
                      <div style={{ fontSize: '1rem' }}>{survey.question}</div>
                      <div className="mt-1 d-flex flex-column">
                        {survey.answer_type === 'rating' ? (
                          <>
                            <small className="text-muted">
                              Rate between 1-5, 1 being the lowest
                            </small>
                            <div className="d-flex justify-content-center align-items-center mt-3 mr-4">
                              <Rating
                                questionID={survey.id}
                                value={
                                  answeredSurveys.find(
                                    answer => answer.survey_id === survey.id
                                  )
                                    ? answeredSurveys.find(
                                        answer => answer.survey_id === survey.id
                                      ).answer
                                    : answers.find(
                                        answer => answer.survey_id === survey.id
                                      )
                                    ? answers.find(
                                        answer => answer.survey_id === survey.id
                                      ).answer
                                    : 0
                                }
                                setValue={
                                  answeredSurveys.length > 0
                                    ? () => {}
                                    : handleAnswer
                                }
                                amount={5}
                              />
                            </div>
                          </>
                        ) : answeredSurveys.find(
                            answer => answer.survey_id === survey.id
                          ) ? (
                          <p>
                            {
                              answeredSurveys.find(
                                answer => answer.survey_id === survey.id
                              ).answer
                            }
                          </p>
                        ) : (
                          <textarea
                            className="form-control mt-2"
                            name={`surveyAnswer-${survey.id}`}
                            id={`surveyAnswer-${survey.id}`}
                            rows="3"
                            placeholder="Enter answer"
                            style={{ resize: 'none' }}
                            value={
                              answers.find(
                                answer => answer.survey_id === survey.id
                              )
                                ? answers.find(
                                    answer => answer.survey_id === survey.id
                                  ).answer
                                : ''
                            }
                            onChange={({ target: { value } }) =>
                              handleAnswer(survey.id, value, 'text')
                            }
                          ></textarea>
                        )}
                      </div>
                    </li>
                  ))}
              </ol>
              {answeredSurveys.length === 0 && (
                <button className="btn btn-brand btn-block">Submit</button>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default withRouter(PulseSurvey)
